import { Provider } from '@angular/core';

import { CommentsDataHttpService } from './abstract';
import { CommentsDataHttpServiceImpl } from './comments-data-http.service';

export const CommentsDataHttpProvider: Provider = {
	provide: CommentsDataHttpService,
	useClass: CommentsDataHttpServiceImpl,
};
